import { ActionReducerMapBuilder, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/dist/tsHelpers';

import { ModelError, State } from 'models';
import { Utforare } from 'models/apiModels/Utforare';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from './storeHelpers';

import BebyggelseApi from 'api/bebyggelseApi';

export const getUtforare = createAsyncThunk<Utforare[], undefined, { rejectValue: ModelError }>(
  'utforare/fetch',
  async (_undefined: undefined, { rejectWithValue }) => {
    const result = await BebyggelseApi.utforare.get();
    return errorOr<Utforare>(result, rejectWithValue);
  }
);

const initialState: State<Utforare[]> = {
  data: undefined,
  error: undefined,
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined
};

const urforareSlice = createSlice({
  name: 'utforare',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<Utforare[]>>>) => {
    builder.addCase(getUtforare.pending, (state: Draft<State<Utforare[]>>, action: PendingActionType): void =>
      pending(state, action)
    );
    builder.addCase(
      getUtforare.fulfilled,
      (state: Draft<State<Utforare[]>>, action: FulfilledActionType<Utforare[]>): void => {
        action.payload = action.payload.map((utf) =>
          utf.organisationsnummer.length === 10
            ? { namn: utf.namn, organisationsnummer: `16${utf.organisationsnummer}` }
            : utf
        );
        fulfilled(state, action);
      }
    );
    builder.addCase(getUtforare.rejected, (state: Draft<State<Utforare[]>>, action: RejectedActionType): void =>
      rejected(state, action)
    );
  }
});

export default urforareSlice.reducer;
